<template>
  <div id="content">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction" />
    <div class="inner">
      <add-button v-if="$_createActionAllowed" :title="'Přidat obrázek' | translate" route-name="imagesNew"></add-button>
      <h1 v-translate>Obrázky</h1>
    </div>
    <div class="inner_white">
      <div class="filter">
        <div class="field_left">
          <select-box
              id="type"
              :options="typeOptions"
              v-model="formFields.type"
              ref="typeref"
          >
            <translate class="translate">Typ</translate>
          </select-box>
        </div>
        <div class="field_right" v-if="!$_loggedUser_selectedOperatorId && $_loggedUser_canChangeOperator">
          <select-box
              id="operatorselect"
              :options="operatorOptions"
              v-model="formFields.id_operator"
              ref="operatorselectref"
          >
            <translate class="translate">Operátor</translate>
          </select-box>
        </div>
        <div class="field_right" v-else>
          <filter-checkbox
              id="globalonly"
              :options="operatorOptions"
              v-model="formFields.operator_only"
              ref="globalonlyref"
          >
            <translate class="translate">Pouze operátorské</translate>
          </filter-checkbox>
        </div>
        <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset" :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
      </div>

      <div class="table_overflow" id="contentBox" data-table-id="image-list">
        <table class="vypis vypis_detail">
        <thead>
        <tr>
          <th class="no_padding drag_drop" />
          <th class="no_padding checkbox" />
          <sorting-table-title
              v-if="entities.length > 0"
              v-for="title in tableTitles"
              :key="title.key"
              :column="title.column"
              :sort="getActiveSort(title.column)"
              :sortable="title.sortable"
              @changeSorting="changeSorting"
          >{{ title.name }}</sorting-table-title>
          <th class="no_padding edit" />
        </tr>
        </thead>

        <images-row
            v-for="entity in entities"
            :entity="entity"
            :key="entity.id"
            @input="select"
            @deleteImage="deleteEntity"
            :selectedEntities="selectedEntities"
            :ref="'vod-videos-row-ref-'+entity.id"
        ></images-row>

        <tr v-if="entities.length === 0">
          <td colspan="5">{{ $gettext('Nebyly nalezeny žádné obrázky.') }}</td>
        </tr>
      </table>
      </div>
      <list-action-line
          :entities="entities"
          :selected-entities="selectedEntities"
          :multiple-action-options="multipleActionOptions"
          :offset="formFields.offset"
          :limit="formFields.limit"
          :total-count="totalCount"
          @run-multiple-action="runMultipleAction"
          @limit="setLimit"
          @offset="setOffset"
          @select-all="toggleSelectAll"
          ref="action_line"
          table-id="image-list"
      ></list-action-line>
    </div>
  </div>
</template>

<script>
import ImagesRow from "./ImagesRow.vue";
import images from "./mixins/images";
import listActions from "@/components/mixins/list-actions"

export default {
  name: "Images",
  components: {
    ImagesRow,
  },
  mixins: [listActions, images],
  data() {
    return {
      operators: [],
      moduleName: 'images',
      entitiesKey: 'images',
      formFields: {
        type: null,
        id_operator: null,
        operator_only: false,
        sort: {
          column: 'sName',
          direction: 'desc',
        },
      },
      typeList: [],
    }
  },
  created(ImageService, OperatorService) {
    this.entityService = ImageService;
    this.operatorService = OperatorService;
    this.createdInit();
    this.operatorService.getOperators()
        .then(data => {
          this.operators = data['operators']
        });
  },
  computed: {
    typeOptions() {
      return [
        { id: null, text: this.$gettext('Všechny') },
        ...this.typeList.map(value => ({
          id: value,
          text: this.getTypeText(value)
        }))
      ];
    },
    tableTitles() {
      let titles = [
          {key: 1, name: this.$gettext('Obrázek'), column: 'sPath', sortable: false},
          {key: 2, name: this.$gettext('Typ'), column: 'sType'},
          {key: 4, name: this.$gettext('Vytvořeno'), column: 'sDateCreated'}
      ];
      if (this.$_loggedUser_selectedOperatorId) {
        titles.splice(2, 0, {
          key: 3,
          name: this.$gettext('Globální'),
          column: 'sOperatorId'
        });
      }else{
        titles.splice(2, 0, {
          key: 3,
          name: this.$gettext('Operátor'),
          column: 'sOperatorName'
        });
      }

      return titles;
    },
    csvHeaders(){
      return this.getCsvHeaderFromSortingTableTitle(this.tableTitles)
    },
    multipleActionOptions() {
      return [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
      ]
    },
    operatorOptions() {
      if (this.operators) {
        return [
            {id: null, text: this.$gettext('Vše')},
            {id: 'global', text: this.$gettext('Pouze globální')},
            {id: 'operator', text: this.$gettext('Pouze operátorské')},
          ...this.operators.map(value => ({
            id: value['id'],
            text: value['name']
          }))];
      } else {
        return [];
      }
    },
  },
  methods: {
    _afterGetEntitiesActions(data) {
      this.typeList = data.image_types;
    },
    loadAdditionalDefaults() {
      let anyChanges = false
      if (this.loadDefaultByKey('type') && this.formFields.type) {
        anyChanges = true
      }
      if (this.$_loggedUser_canChangeOperator
          && this.loadDefaultByKey('id_operator')
          && this.formFields.id_operator
      ) {
        anyChanges = true
      }
      if (!this.$_loggedUser_canChangeOperator
          && this.loadDefaultByKey('operator_only')
          && this.formFields.operator_only
      ) {
        anyChanges = true
      }
      return anyChanges
    },
    saveFilterValues() {
      this.setUserSetting('type', this.formFields.type);
      this.setUserSetting('id_operator', this.formFields.id_operator);
      this.setUserSetting('operator_only', this.formFields.operator_only);
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/images/ImagesList.vue